import React from "react";

/** Bandeau KPI : présences, absences, taux moyen */
const StatStrip = ({ presents = 0, absents = 0, rate = 0 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800 bg-white/90 dark:bg-slate-900/40 p-4">
        <div className="text-xs opacity-70">Présences (mois)</div>
        <div className="text-2xl font-semibold">{presents}</div>
      </div>
      <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800 bg-white/90 dark:bg-slate-900/40 p-4">
        <div className="text-xs opacity-70">Absences (mois)</div>
        <div className="text-2xl font-semibold">{absents}</div>
      </div>
      <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800 bg-white/90 dark:bg-slate-900/40 p-4">
        <div className="text-xs opacity-70">Taux moyen de présence</div>
        <div className="text-2xl font-semibold">{rate}%</div>
        <div className="mt-2 h-2 rounded bg-slate-200 dark:bg-slate-800 overflow-hidden">
          <div
            className="h-2 bg-emerald-500"
            style={{ width: `${Math.min(100, Math.max(0, rate))}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default StatStrip;
